<template>
  <ClientOnly>
    <div
      class="inline-flex items-center gap-0.5 rounded-full bg-brand-950/60 p-1 ring-1 ring-brand-700/80"
      role="group"
      aria-label="Temă afișare"
    >
      <button
        v-for="option in options"
        :key="option.value"
        type="button"
        class="inline-flex items-center gap-1.5 rounded-full px-2.5 py-1.5 text-xs font-medium transition-all duration-200"
        :class="preference === option.value
          ? 'bg-brand-600 text-white shadow-sm'
          : 'text-brand-300 hover:bg-brand-800/80 hover:text-white'"
        :aria-pressed="preference === option.value"
        :title="option.label"
        @click="setPreference(option.value)"
      >
        <UIcon :name="option.icon" class="size-3.5 shrink-0" />
        <span class="hidden sm:inline">{{ option.label }}</span>
      </button>
    </div>

    <template #fallback>
      <div
        class="inline-flex h-8 w-[7.5rem] sm:w-[11.5rem] items-center rounded-full bg-brand-950/60 p-1 ring-1 ring-brand-700/80"
        aria-hidden="true"
      />
    </template>
  </ClientOnly>
</template>

<script setup lang="ts">
type ThemePreference = 'system' | 'light' | 'dark'

const colorMode = useColorMode()

const preference = computed(() => (colorMode.preference || 'system') as ThemePreference)

const options: { value: ThemePreference, label: string, icon: string }[] = [
  { value: 'system', label: 'Sistem', icon: 'i-heroicons-computer-desktop' },
  { value: 'light', label: 'Luminos', icon: 'i-heroicons-sun' },
  { value: 'dark', label: 'Întunecat', icon: 'i-heroicons-moon' },
]

function setPreference(value: ThemePreference) {
  colorMode.preference = value
}
</script>
